

import * as React from "react";
import {
    Card,
    CardHeader,
    CardContent,
    List,
    ListItem,
    ListItemText,
    Divider,
    Chip,
    Typography,
    Tooltip,
    Box,
} from "@mui/material";
import { FaArrowTrendDown, FaArrowTrendUp, FaMinus } from 'react-icons/fa6';

const formatSignedPercent = (v) => {
    const n = Number(v);
    if (!Number.isFinite(n) || n === 0) return "0%";
    return `${n > 0 ? "+" : ""}${n}%`;
};

const trendIconColor = (n) =>
    n > 0 ? "error" : n < 0 ? "success" : "default"; // ↑ bad (more negatives) = red; ↓ good = green

const TrendChip = ({ value }) => {
    const n = Number(value);
    const label = formatSignedPercent(n);
    const color = trendIconColor(n);

    const icon =
        n > 0 ? (
            <FaArrowTrendUp />
        ) : n < 0 ? (
            <FaArrowTrendDown />
        ) : (
            <FaMinus />
        );

    return (
        <Chip
            size="small"
            variant="outlined"
            color={color === "default" ? undefined : color}
            icon={icon}
            label={label}
        />
    );
};

export default function RecentPositiveKeywords({ data, title = "Recent Positive Keywords", limit = 5 }) {
    const items = Array.isArray(data?.currentPositiveTop) ? data.currentPositiveTop.slice(0, limit) : [];

    return (
        <Card variant="outlined" sx={{ height: "100%" }}>
            <CardHeader
                title={title}
                subheader={
                    <Typography variant="body2" color="text.secondary">
                        Week-over-week change in positive mentions
                    </Typography>
                }
            />
            <CardContent sx={{ pt: 0 }}>
                {items.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No recent negative keywords found.
                    </Typography>
                ) : (
                    <List disablePadding>
                        {items.map((el, idx) => {
                            const key = `${el?.label ?? "item"}-${idx}`;
                            const percent = Number(el?.changePercentage ?? 0);

                            return (
                                <React.Fragment key={key}>
                                    <ListItem
                                        disableGutters
                                        // secondaryAction keeps the metric right-aligned without custom flex
                                        secondaryAction={
                                            <Tooltip
                                                title={percent > 0 ? "Increase in negative mentions" : percent < 0 ? "Decrease in negative mentions" : "No change"}
                                                arrow
                                            >
                                                <Box>
                                                    <TrendChip value={percent} />
                                                </Box>
                                            </Tooltip>
                                        }
                                    >
                                        <ListItemText
                                            primary={el?.label ?? "—"}
                                            secondary={typeof el?.count === "number" ? `${el.count} mention${el.count === 1 ? "" : "s"}` : null}
                                            primaryTypographyProps={{ variant: "body1" }}
                                            secondaryTypographyProps={{ variant: "caption", color: "text.secondary" }}
                                        />
                                    </ListItem>
                                    {idx < items.length - 1 && <Divider component="li" />}
                                </React.Fragment>
                            );
                        })}
                    </List>
                )}
            </CardContent>
        </Card>
    );
}
